import { useMutation } from '@tanstack/react-query';

import { ClearVoucherUsersPayload, ClearVoucherUsersResponse, clearVoucherUsers } from '~/services/PromoService';

export function useClearVoucherUsers() {
  return useMutation<ClearVoucherUsersResponse, Error, ClearVoucherUsersPayload>({
    mutationFn: async (payload) => clearVoucherUsers(payload),
  });
}
